import { Component, Input, Output, EventEmitter } from '@angular/core'

import { UsersService } from '../../services/users.service'
import { User } from '../../models/user.model'

@Component({
  selector: 'ld-select-user',
  template: require('./select-user.component.html'),
  styles: [require('./select-user.component.css')]
})
export class SelectUserComponent {
  @Input('active') active: User
  @Input('filteredId') filteredId = ''
  @Output('activeChange') activeChange = new EventEmitter<User>()
  private options = []

  constructor (private usersService: UsersService) {}

  async ngOnInit () {
    const users = await this.usersService.get('', false).catch(() => [new User()])

    this.options = users
      .filter((user) => user.id !== this.filteredId)
      .map((user) => {
        return {
          user: user,
          name : `${user.firstname} ${user.lastname}`
        }
      })
  }

  onChange (user: User) {
    this.activeChange.emit(user)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/select-user/select-user.component.ts